import { isDevelopmentEnvironment } from "@/lib/env";

// Ligado: a funcionalidade só aparece fora de produção (localhost e homologação/DEV), usando a mesma
// verificação de ambiente do resto do sistema (@/lib/env). Desligue (false) para liberar em produção.
export const SCHEDULED_ORDER_CREATED_BY_COLUMN_DEV_ONLY = true;

export let isScheduledOrderCreatedByColumnEnabled = false;

// Coluna "Criado Por" na listagem de pedidos programados do backoffice, ocultada em 01/10.
// Comente a linha abaixo para voltar a ocultá-la.
isScheduledOrderCreatedByColumnEnabled = !SCHEDULED_ORDER_CREATED_BY_COLUMN_DEV_ONLY || isDevelopmentEnvironment;
